<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12" lg="12">
        <b-card header="AAI Support Center">
          <el-form
            :model="supportForm"
            :rules="rules"
            ref="newSupportForm"
            label-width="160px"
            class="demo-settingsForm"
            label-position="top"
          >
            <!-- <el-form-item label="Module">
              <el-select v-model="supportForm.module" placeholder="please select the AAI Module">
                <el-option label="Other" value="admin-spa"></el-option>
                <el-option label="Client Test Taking Module" value="test-spa"></el-option>
                <el-option label="Client Test Taking Images" value="client-images"></el-option>
                <el-option label="Administrative / Distributor Module Issues" value="admin-spa"></el-option>
                <el-option label="Report Email / Generation Issues" value="report-engine"></el-option>
                <el-option label="Report Viewing Issues" value="pdf-vie-service"></el-option>
                <el-option label="Export Related Issues" value="export-service"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="Title:" prop="title">
              <el-input v-model="supportForm.title" placeholder="a brief name for the issue"></el-input>
            </el-form-item>
            <el-form-item label="Describe The bug:" prop="bug">
              <el-input
                type="textarea"
                v-model="supportForm.describe"
                :autosize="{ minRows: 6, maxRows: 10 }"
                placeholder="A clear and concise description of what the bug is."
              ></el-input>
            </el-form-item>

            <el-form-item label="To Reproduce:" prop="reproduce">
              <el-input
                type="textarea"
                v-model="supportForm.reproduce"
                :autosize="{ minRows: 6, maxRows: 10 }"
              ></el-input>
            </el-form-item>

            <el-form-item label="Expected behavior:" prop="behavior">
              <el-input
                v-model="supportForm.behavior"
                type="textarea"
                :autosize="{ minRows: 6, maxRows: 10 }"
                placeholder="A clear and concise description of what you expected to happen."
              ></el-input>
            </el-form-item>

            <el-form-item
              label="Desktop (please complete the following information):"
              prop="context"
            >
              <el-input
                v-model="supportForm.desktop"
                type="textarea"
                :autosize="{ minRows: 6, maxRows: 10 }"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="Smartphone (please complete the following information):"
              prop="context"
            >
              <el-input
                v-model="supportForm.smartphone"
                type="textarea"
                :autosize="{ minRows: 6, maxRows: 10 }"
              ></el-input>
            </el-form-item>

            <el-form-item label="Additional context:" prop="context">
              <el-input
                v-model="supportForm.context"
                type="textarea"
                :autosize="{ minRows: 6, maxRows: 10 }"
                placeholder="Add any other context about the problem here."
              ></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="saveSupportTicket()">Submit Issue</el-button>
            </el-form-item>
          </el-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import axios from '../../shared/axios';
import { setTimeout } from 'timers';
export default {
  data() {
    return {
      supportForm: {
        module: 'admin-spa',
        title: undefined,
        describe: undefined,
        reproduce:
          "Steps to reproduce the behavior:\n1. Go to '...'\n2. Click on '....'\n3. Scroll down to '....'\n4. See error",
        behavior: undefined,
        desktop:
          ' - OS: [e.g. macOS, Windows10]\n - Browser [e.g. Edge, Safari]\n - Version [e.g. 22]',
        smartphone:
          ' - OS: [e.g. iOS]\n - Browser [e.g. Chrome, Safari]\n - Version [e.g. 22]\n',
        context: undefined
      },
      rules: {
        module: [
          {
            required: true,
            message: 'Please select a module',
            trigger: 'blur'
          }
        ],
        title: [
          {
            required: true,
            message: 'Please input the title',
            trigger: 'blur'
          }
        ],
        describe: [
          {
            required: true,
            message: 'Please input the form to describe',
            trigger: 'blur'
          }
        ],
        reproduce: [
          {
            required: true,
            message: 'Please input form to reproduce',
            trigger: 'blur'
          }
        ]
      }
    };
  },
  created() {},
  methods: {
    saveSupportTicket() {
      this.$refs['newSupportForm'].validate(valid => {
        if (valid) {
          axios
            .post('support/issue', this.supportForm)
            .then(r => {
              // success message
              this.$message({
                message: 'Created new support ticket',
                type: 'success'
              });
              this.supportForm = {
                module: undefined,
                title: undefined,
                describe: undefined,
                reproduce:
                  "Steps to reproduce the behavior:\n1. Go to '...'\n2. Click on '....'\n3. Scroll down to '....'\n4. See error",
                behavior: undefined,
                desktop:
                  ' - Device: [e.g. iPhone6]\n - OS: [e.g. iOS8.1]\n - Browser [e.g. stock browser, safari]\n - Version [e.g. 22]',
                smartphone:
                  ' - OS: [e.g. iOS]\n - Browser [e.g. chrome, safari]\n - Version [e.g. 22]\n',
                context: undefined
              };
            })
            .catch(e => {
              console.log(e);
              this.$message.error('Unable to create new support ticket');
            });
        } else {
          this.$message.error('Form not completed filled out');
          return false;
        }
      });
    }
  }
};
</script>
